import React from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { getCurrentCulture } from "@utils";
import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import BetBuilderPicksQuotaButton from "../BetBuilderPicksQuotaButton";
import { analyticsTracker } from "@utils/analytics";
import { BetBuilderPicksStore } from "@state/quick-play-store/BetBuilderPicksStore";
import { ChangePageButton } from "@state/quick-play-store/MostPlayedTicketsStore";
import { QuickPlayPopupsPagination } from "@features/quick-play/mobile/common/QuickPlayPopupsPagination";

export default observer(function BetBuilderPicksPopupFooter(props: {
	store: BetBuilderPicksStore;
	slip: BetBuilderPick;
	slipNumber: number;
}) {
	const t = useTranslation().t;
	const isOnQuickPlayPage = location.pathname.includes("bet-builder-picks");

	const isPrevAndNextDisabled = props.store.currentActiveList.size == 1;

	return (
		<div className="popup__footer popup__footer--bordered">
			<BetBuilderPicksQuotaButton
				BBPick={props.slip}
				isInPopup
				store={props.store}
			/>

			<div className="popup__footer__row u-display--f--center">
				{props.slipNumber != null && !isPrevAndNextDisabled && (
					<QuickPlayPopupsPagination
						onPrevClick={() => {
							props.store.changePage(ChangePageButton.PREVIOUS);
							analyticsTracker.trackModalSwitcher("bb-picks");
						}}
						onNextClick={() => {
							props.store.changePage(ChangePageButton.NEXT);
							analyticsTracker.trackModalSwitcher("bb-picks");
						}}
						isDisabled={isPrevAndNextDisabled}
						currentPage={props.slipNumber + 1}
						totalPages={props.store.currentActiveList.size}
					/>
				)}
			</div>

			{!isOnQuickPlayPage && (
				<Link
					to={`/${getCurrentCulture()}/quick-play/bet-builder-picks`}
					className="btn btn--sml btn--block btn--ghost popup__btn popup__btn--tertiary"
					type="button"
				>
					<div className="btn__label">{t("COMMON.SHOW_MORE")}</div>
				</Link>
			)}
		</div>
	);
});
